import { MEDIA_OVERLAY_BLUR } from '@components/MediaOverlayIconButton/mediaOverlayIconButton.styles';
import { Theme, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const HEADER_HEIGHT = 48;
const MEDIA_HEIGHT = `calc(100vh - ${HEADER_HEIGHT + 16}px)`;
const ZOOM_SCALE = 2;

type ProductDetailZoomStylesParams = {
  mediaAspectRatio: number;
};

export const useProductDetailZoomStyles = makeStyles<ProductDetailZoomStylesParams>()(
  (theme: Theme, { mediaAspectRatio }) => ({
    paper: {
      backgroundColor: 'transparent',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      boxSizing: 'border-box',
      height: HEADER_HEIGHT,
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      backgroundColor: 'transparent',
      backdropFilter: MEDIA_OVERLAY_BLUR,
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
      },
    },
    headerTitle: {
      flex: 1,
      minWidth: 0,
      color: theme.palette.common.white,
    },
    mediaArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minHeight: 0,
      gap: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        alignSelf: 'stretch',
        width: '100%',
        gap: 0,
        paddingBottom: 0,
      },
    },
    swipeableArea: {
      flex: 1,
      minWidth: 0,
      height: '100%',
    },
    mediaSlot: {
      display: 'flex',
      height: '100%',
      minWidth: 0,
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        flex: 1,
        width: '100%',
        '& > *': {
          flex: 1,
          minWidth: 0,
        },
      },
    },
    media: {
      display: 'block',
      boxSizing: 'border-box',
      objectFit: 'cover',
      width: 'auto',
      aspectRatio: mediaAspectRatio,
      borderRadius: theme.shape.borderRadius2xl,
      border: `0.5px solid ${alpha(theme.palette.common.black, 0.15)}`,
    },
    fittedMedia: {
      height: MEDIA_HEIGHT,
      maxWidth: '100%',
      cursor: 'zoom-in',
    },
    zoomedMedia: {
      height: `calc(${MEDIA_HEIGHT} * ${ZOOM_SCALE})`,
      margin: '0 auto',
      cursor: 'zoom-out',
    },
    mobileMedia: {
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: 0,
    },
    floatingCloseControl: {
      position: 'fixed',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },
    navControl: {
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
      },
    },
    navControlPrevious: {
      [theme.breakpoints.down('sm')]: {
        left: theme.spacing(1),
      },
    },
    navControlNext: {
      [theme.breakpoints.down('sm')]: {
        right: theme.spacing(1),
      },
    },
  }),
);
